// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ComponentSubscriptionReplaceController = function ($routeParams, $http, $location, Order, gettextCatalog, gettext, $scope, $modalInstance, componentSubscriptionId, ComponentSubscription, ComponentSubscriptionByContract, Contract, contract, PUtill) {
    $scope.contract = contract;
    $scope.areDatesEqual = PUtill.areDatesEqual;
    $scope.ChangeDate = contract.NextBillingDate;
    
    $scope.componentSubscription = ComponentSubscription.get({ componentSubscriptionId: componentSubscriptionId }, function (comp) {
        $scope.newComponentSubscription = new ComponentSubscriptionByContract();
        $scope.newComponentSubscription.Quantity = comp.Quantity;
        $scope.newComponentSubscription.Memo = comp.Memo;
        $scope.newComponentSubscription.ComponentId = comp.ComponentId;
        if (comp.ProductOverride)
            $scope.newComponentSubscription.ProductOverride = comp.ProductOverride;
    });
    
    $scope.cancel = function () { $modalInstance.close(); };

    $scope.getDateToTimeAdjusted = function(date) {
        return Contract.getDateToPhaseStartTimeAdjusted($scope.contract, date);
    };    
    
    function replaceComponentSubscription() {
        let dto = {
            Quantity: $scope.newComponentSubscription.Quantity,
            StartDate: $scope.ChangeDate,
            Memo: $scope.newComponentSubscription.Memo,
            ComponentId: $scope.componentSubscription.ComponentId,
            ProductOverride: $scope.componentSubscription.ProductOverride,
        };
        
        $http({
            method: "POST",
            url: "/api/v1/componentSubscriptions/" + componentSubscriptionId + "/replace",
            params: null,
            data: dto,
            headers: {},
            cache: false
        }).then(function () {
            $location.path('/contracts/' + $routeParams.contractId);
            $modalInstance.close();
            $scope.notify("success", gettextCatalog.getString(gettext("Component subscription replaced successfully")));
        }, function () {
            $scope.saving = false;
        });
    }

    $scope.save = function () {
        if (!$scope.ChangeDate) {
            $scope.showErrorBox("Date is required");
            return;
        }

        if (!$scope.newComponentSubscription.Quantity) {
            $scope.showErrorBox("Quantity should be greater than 0");
            return;
        }

        let startDate = new Date($scope.componentSubscription.StartDate);
        if (startDate > $scope.ChangeDate) {
            $scope.showErrorBox("Change date can't be before component subscription start date");
            return;
        }

        if ($scope.componentSubscription.BilledUntil && moment($scope.componentSubscription.BilledUntil).diff($scope.ChangeDate, 'minutes')>0) {
            $scope.yesCancel(gettextCatalog.getString(gettext("Do you want to proceed?")),
                gettextCatalog.getString(gettext("Changing the quantity of component subscriptions in an already billed period" +
                    " might result in a credit note or a new invoice for already billed items.")),
                function () { replaceComponentSubscription(); },
                function () { }
            );
        }
        else replaceComponentSubscription();
    };
};

ComponentSubscriptionReplaceController.$inject = [
    '$routeParams',
    '$http',
    '$location',
    'Order',
    'gettextCatalog',
    'gettext',
    '$scope',
    '$uibModalInstance',
    'componentSubscriptionId',
    'ComponentSubscription',
    'ComponentSubscriptionByContract',
    'Contract',
    'contract',
    'PUtill'    
];
